import React from 'react'

const LenderHeroComp = () => {
  return (
    <section id="c-heroLender" className="c-sectionHero">
		<div className="container">
			<div className="row">
				<div className="col-md-5 col-sm-12 c-heroContentCol">
					<div className="c-heroContent">
						<h5 className="c-heading46Bold">Grow your EV lending portfolio, driven by AI!</h5>
						<p className="c-para22Regular">FI-MEN technology assists you in making smart financial decisions for green mobility financing</p>
						<a href="#c-sectionRequestInfoForm" className="c-btnOrangeSolidSharp">Get in Touch &nbsp;&nbsp; <b>></b></a>
					</div>
				</div>
				<div className="col-md-7 col-sm-12 c-heroImgCol">
					<img src="./images/lender/hero_lender_main.png" className="img-fluid" alt="" />
				</div>
			</div>
		</div>
	</section>
  )
}

export default LenderHeroComp